import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";

import authReducer from "../features/auth/authSlice";

import { makeCrudSlice } from "../features/_shared/crudSliceFactory";
import { statesApi } from "../api/statesApi";
import { regionsApi } from "../api/regionsApi";
import { countiesApi } from "../api/countiesApi";
import { countyLinksApi } from "../api/countyLinksApi";
import { auctionRuleTemplatesApi } from "../api/auctionRuleTemplatesApi";
import { auctionsApi } from "../api/auctionsApi";
import { usersApi } from "../api/usersApi";
import { auctionPropertiesApi } from "../api/auctionPropertiesApi";
import dashboardReducer, { dashboardActions, dashboardThunks } from "../features/dashboard/dashboardSlice";


const statesSlice = makeCrudSlice({ name: "states", api: statesApi });
const regionsSlice = makeCrudSlice({ name: "regions", api: regionsApi });
const countiesSlice = makeCrudSlice({ name: "counties", api: countiesApi });
const countyLinksSlice = makeCrudSlice({
  name: "countyLinks",
  api: countyLinksApi,
});
const auctionRuleTemplatesSlice = makeCrudSlice({
  name: "auctionRuleTemplates",
  api: auctionRuleTemplatesApi,
});
const auctionsSlice = makeCrudSlice({
  name: "auctions",
  api: auctionsApi,
});
const auctionPropertiesSlice = makeCrudSlice({
  name: "auctionProperties",
  api: auctionPropertiesApi,
});
const usersSlice = makeCrudSlice({
  name: "users",
  api: usersApi,
});

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    states: statesSlice.reducer,
    regions: regionsSlice.reducer,
    counties: countiesSlice.reducer,
    countyLinks: countyLinksSlice.reducer,
    auctionRuleTemplates: auctionRuleTemplatesSlice.reducer,
    auctions: auctionsSlice.reducer,
    auctionProperties: auctionPropertiesSlice.reducer,
    users: usersSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(process.env.NODE_ENV === "development" ? logger : []),
});

// exports práticos (igual states)
export const statesThunks = statesSlice.thunks;
export const statesActions = statesSlice.actions;

export const regionsThunks = regionsSlice.thunks;
export const regionsActions = regionsSlice.actions;

export const countiesThunks = countiesSlice.thunks;
export const countiesActions = countiesSlice.actions;

export const countyLinksThunks = countyLinksSlice.thunks;
export const countyLinksActions = countyLinksSlice.actions;

export const auctionRuleTemplatesThunks = auctionRuleTemplatesSlice.thunks;
export const auctionRuleTemplatesActions = auctionRuleTemplatesSlice.actions;

export const auctionsThunks = auctionsSlice.thunks;
export const auctionsActions = auctionsSlice.actions;

export const usersThunks = usersSlice.thunks;
export const usersActions = usersSlice.actions;

export const auctionPropertiesThunks = auctionPropertiesSlice.thunks;
export const auctionPropertiesActions = auctionPropertiesSlice.actions;

export { dashboardActions, dashboardThunks };
